import { ICON_TYPES } from './iconTypes';

export default {
	resources: {
		name: 'bookshelf',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Library',
	},
	export: {
		name: 'file-export',
		type: ICON_TYPES.fontAwesome5,
		text: 'Export'
	},
	text: {
		name: 'file-text-o',
		type: ICON_TYPES.fontAwesome,
		text: 'Text'
	},
	pdf: {
		name: 'file-pdf-o',
		type: ICON_TYPES.fontAwesome,
		text: 'PDF'
	},
	pageAdd: {
		name: 'note-add',
		type: ICON_TYPES.materialIcons,
		text: 'Add Page'
	},
	book: {
		name: 'book-outline',
		type: ICON_TYPES.ionicon,
		text: 'Book',
	},
	page: {
		name: 'document-outline',
		type: ICON_TYPES.ionicon,
		text: 'Page',
	},
	share: {
		name: 'share-outline',
		type: ICON_TYPES.ionicon,
		text: 'Share',
	}
};